module.exports = __webpack_public_path__ + "static/media/logo.93826ca9.png";